import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { NearbyVenue } from 'firebase/mapsClient';
import { accountCleared } from '../actions';
import type { RootState } from '../store';

export interface VenueSearchLocation {
  latitude: number;
  longitude: number;
}

interface VenueSearchState {
  hasSearched: boolean;
  location: VenueSearchLocation | null;
  venues: NearbyVenue[];
}

const initialState: VenueSearchState = {
  hasSearched: false,
  location: null,
  venues: [],
};

export const venueSearchSlice = createSlice({
  name: 'venueSearch',
  initialState,
  reducers: {
    venueSearchStarted: (state, action: PayloadAction<VenueSearchLocation>) => ({
      ...state,
      hasSearched: true,
      location: action.payload,
    }),
    venueSearchReceived: (state, action: PayloadAction<NearbyVenue[]>) => ({
      ...state,
      venues: action.payload,
    }),
    venueSearchCleared: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(accountCleared, () => initialState);
  },
});

export const {
  venueSearchCleared,
  venueSearchReceived,
  venueSearchStarted,
} = venueSearchSlice.actions;

export const selectVenueSearch = (state: RootState) => state.venueSearch;
export const selectVenueSearchHasSearched = (state: RootState) => state.venueSearch.hasSearched;
export const selectVenueSearchLocation = (state: RootState) => state.venueSearch.location;
export const selectVenueSearchVenues = (state: RootState) => state.venueSearch.venues;

export default venueSearchSlice.reducer;
